import { Box, Typography, Button, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  HeaderLeftContent,
  HeaderRightContent,
  ResponsiveStyledHeader,
} from "../Common/styles/header";
import {
  a11yProps,
  MainTabPanel,
  StyledTab,
  StyledTabs,
} from "../Common/UI/TabPanel";
import { useSearchParams } from "react-router-dom";
// import AppointmentDateSelector from "./AppointmentDateSelector";
import { DateTime } from "luxon";
import { AxiosResponse } from "axios";
import http from "../../utils/http";
import { errorToastMessage } from "../../utils/toast";
import Appointments from "./Appointments/Appointments";
import AddAppointmentDrawer from "./Appointments/AddAppointmentDrawer";
import { pageSize } from "../Common/styles/table";

const ParticipantAppointments = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [type, setType] = useState(searchParams.get("type") ?? "upcoming");

  const [page, setPage] = useState<number>(0);
  const [totalAppointmentCount, setTotalAppointmentCount] = useState<number>(0);
  // const [currentDate, setCurrentDate] = useState(DateTime.now().startOf("day"));
  // const [selectedDate, setSelectedDate] = useState(currentDate);

  const [loading, setLoading] = useState<boolean>(true);
  const [appointmentsData, setAppointmentsData] = useState<any>([]);
  const [toggle, setToggle] = useState<boolean>(true);
  const [selectedData, setSelectedData] = useState<any>({});
  const studyId = localStorage.getItem("study-id");

  const handleChange = (_1: any, val: string) => {
    setType(val);
    // setCurrentDate(DateTime.now().startOf("day"));
    // setSelectedDate(DateTime.now().startOf("day"));
  };

  // const startOfDay = selectedDate.startOf("day").toUTC().toISO();
  // const endOfDay = selectedDate.endOf("day").toUTC().toISO();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        let url = `/participant/study/${studyId}/appointments?page=${
          page + 1
        }&size=${pageSize}`;
        if (type === "upcoming") {
          url += `&timeframe=upcoming`;
        } else if (type === "past") {
          url += `&timeframe=past`;
        } else if (type === "cancelled") {
          url += `&status=canceled`;
        }
        const res: AxiosResponse = await http.get(url);
        const data = res.data?.data;

        const newData = data?.rows?.map((item: any) => ({
          id: item?.id,
          name: item?.inviters[0]?.inviter?.firstName
            ? item?.inviters[0]?.inviter?.lastName
              ? `${item?.inviters[0]?.inviter?.firstName} ${item?.inviters[0]?.inviter?.lastName}`
              : item?.inviters[0]?.inviter?.firstName
            : "",
          title: item?.title,
          inviterId: item?.inviters[0]?.inviter?.id,
          date: DateTime.fromISO(item?.scheduledFrom).toFormat("MMM dd, yyyy"),
          startTime: DateTime.fromISO(item?.scheduledFrom).toFormat("hh:mm a"),
          endTime: DateTime.fromISO(item?.scheduledTo).toFormat("hh:mm a"),
          scheduledFrom: item?.scheduledFrom,
          scheduledTo: item?.scheduledTo,
          status: item?.status,
          studyId: item?.studyId,
        }));

        setTotalAppointmentCount(data?.count || 0);
        setAppointmentsData(newData || []);
        setLoading(false);
      } catch (err) {
        errorToastMessage(err as Error);
        setLoading(false);
      }
    };

    fetchData();
  }, [setLoading, setAppointmentsData, type, toggle, studyId, page]);

  const openDrawer = (item: any) => {
    setShowDrawer(true);
    setSelectedData(item);
  };

  const closeDrawer = () => {
    setShowDrawer(false);
    setSelectedData(null);
  };

  const refreshPage = () => {
    setToggle((prev) => !prev);
  };

  const handleChangePage = (_1: any, newPage: number) => {
    setPage(newPage);
  };

  useEffect(() => {
    const params = new URLSearchParams();
    if (type) {
      params.set("type", type);
    }
    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, type]);

  return (
    <>
      <ResponsiveStyledHeader
        sx={{
          height: { xs: type === "upcoming" ? "118px" : "80px", sm: "80px" },
        }}
      >
        <Box sx={{ ...HeaderLeftContent, gap: 1 }}>
          <Typography fontSize={20} fontWeight={600} color="text.primary">
            Appointments
          </Typography>
        </Box>

        {type === "upcoming" && (
          <Box
            sx={{
              ...HeaderRightContent,
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <Button
              sx={{ width: "100%", borderRadius: { xs: "8px", sm: "12px" } }}
              variant="contained"
              onClick={openDrawer}
            >
              Schedule New Appointment
            </Button>
          </Box>
        )}
      </ResponsiveStyledHeader>
      <Box
        sx={{
          borderTop: 1,
          borderColor: "#E5E7EB",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          bgcolor: "#fff",
        }}
      >
        <StyledTabs value={type} onChange={handleChange}>
          <StyledTab label="Upcoming" value="upcoming" {...a11yProps(0)} />
          <StyledTab label="Past" value="past" {...a11yProps(1)} />
          <StyledTab label="Cancelled" value="cancelled" {...a11yProps(2)} />
        </StyledTabs>
        {/* <Box sx={{ ...HeaderRightContent, gap: 1, my: 2 }}>
          <AppointmentDateSelector
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            currentDate={currentDate}
            setCurrentDate={setCurrentDate}
            type={type}
          />
        </Box> */}
      </Box>
      <Box
        sx={{
          height: {
            xs:
              type === "upcoming" ? "calc(100% - 175px)" : "calc(100% - 137px)",
            sm: "calc(100% - 137px)",
          },
          overflow: "auto",
        }}
      >
        <MainTabPanel value={type} index={type}>
          <Appointments
            loading={loading}
            type={type}
            appointmentsData={appointmentsData}
            refreshPage={refreshPage}
            openDrawer={openDrawer}
            totalAppointmentCount={totalAppointmentCount}
            page={page}
            handleChangePage={handleChangePage}
          />
        </MainTabPanel>
      </Box>
      {showDrawer && (
        <AddAppointmentDrawer
          showDrawer={showDrawer}
          closeDrawer={closeDrawer}
          refreshPage={refreshPage}
          selectedData={selectedData}
        />
      )}
    </>
  );
};

export default ParticipantAppointments;
